// extracted by mini-css-extract-plugin
module.exports = {"menu":"menu","menu-list":"menu-list","icon":"icon","ic-go-right":"ic-go-right"};